import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Paper, Tab, Tabs, Grid, Typography } from '@mui/material';
import { HomeContext } from '../utils/contexts/homeContext';
import { GetGetReminderDataAPIUrl } from '../utils/extensions/functionEx';
import PageLoading from '../shared/components/backdrop';
import ServiceReminder from './serviceReminder';
import ServiceBookingReminder from './bookingReminder'
import NurseVacationReminder from './nurseLeaveReminder';
import { useCookies } from 'react-cookie';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const ReminderPage = (props) => {

    const { ShowAPIError, OpenErrorAlert, homeState, ClearLoggedUser } = useContext(HomeContext);

    const [dbReminderData, setDbReminderData] = useState(null);
    const [tableName, setTableName] = React.useState('patientServices');
    const [isOpenPageLoad, setIsOpenPageLoad] = useState(false);

    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    useEffect(() => {
        async function fetchReminderData() {
            getReminderData();
        }
        fetchReminderData();
    }, []);

    const getReminderData = async () => {
        try {
            setIsOpenPageLoad(true);
            let tempJson = [];

            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(GetGetReminderDataAPIUrl(homeState.loggedUser.companyCode), { headers: headers });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                tempJson = await response.json();
            } else {
                ShowAPIError(response)
            }

            setDbReminderData({ ...tempJson });
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
        }
    }

    const handleTabChange = (event, newValue) => {
        setTableName(newValue);
    };

    const handlePageLoadingClose = () => {
        setIsOpenPageLoad(false);
    }


    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                {
                    isOpenPageLoad &&
                    <PageLoading isOpenPageLoading={isOpenPageLoad} handleClose={handlePageLoadingClose} />
                }
                <Box sx={{ width: '100%' }}>
                    <Paper>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="stretch"
                        >
                            <Grid size={12}>
                                <Typography variant="h5" sx={{ p: 2 }}>
                                    Reminders
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Tabs
                        value={tableName}
                        onChange={handleTabChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="Reminder Tabs"
                    >
                        <Tab value="patientServices" label="Patient Services" />
                        <Tab value="nurseBookings" label="Nurse Bookings" />
                        <Tab value="nurseVacations" label="Nurse Vacations" />
                    </Tabs>
                    <CustomTabPanel value={tableName} index={'patientServices'}>
                        <ServiceReminder dbPatientServices={dbReminderData && dbReminderData.patient_services ? dbReminderData.patient_services : []} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tableName} index={"nurseBookings"}>
                        <ServiceBookingReminder dbNurseBookings={dbReminderData && dbReminderData.nurse_bookings ? dbReminderData.nurse_bookings : []} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tableName} index={"nurseVacations"}>
                        <NurseVacationReminder nurseVacations={dbReminderData && dbReminderData.nurse_vacations ? dbReminderData.nurse_vacations : []} />
                    </CustomTabPanel>
                </Box>
            </Stack>
        </Box>
    );
}
export default ReminderPage;